<template>
    <UiModalMobile :is-open="isOpen" title="Sort by" @close="handleCancel">
        <template #content>
            <fieldset class="flex flex-col gap-6">
                <legend class="sr-only">Sort options</legend>
                <label
                    v-for="option in OPTIONS"
                    :key="option.value"
                    class="flex items-center gap-2 cursor-pointer group"
                    @click="draft = option.value"
                >
                    <div class="relative flex items-center">
                        <input
                            type="radio"
                            name="insightsSortOption"
                            :value="option.value"
                            class="absolute opacity-0"
                            :checked="draft === option.value"
                        />
                        <span
                            :class="[
                                draft === option.value
                                    ? 'bg-10x-orange'
                                    : 'bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600',
                                'w-4 h-4 rounded-full flex items-center justify-center',
                            ]"
                        >
                            <span
                                v-if="draft === option.value"
                                class="w-1.5 h-1.5 bg-white rounded-full"
                            ></span>
                        </span>
                    </div>
                    <span
                        class="text-base text-slate-800 group-hover:text-slate-900 dark:text-slate-100 dark:group-hover:text-white"
                    >
                        {{ option.label }}
                    </span>
                </label>
            </fieldset>
        </template>
        <template #footer>
            <div class="px-6 py-1 pb-8 bg-white dark:bg-slate-800">
                <button
                    class="w-full px-4 py-2.5 bg-slate-900 text-white rounded shadow text-sm font-medium hover:bg-slate-800 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2"
                    @click="handleApply"
                >
                    Apply
                </button>
            </div>
        </template>
    </UiModalMobile>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useCardBenefitsStore } from '@/store/card-benefits';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);

const OPTIONS = [
    { value: 'benefit_asc', label: 'Benefit A-Z' },
    { value: 'used_desc', label: 'Used in period (highest first)' },
    { value: 'used_asc', label: 'Used in period (lowest first)' },
    { value: 'unused_desc', label: 'Unused (highest first)' },
    { value: 'unused_asc', label: 'Unused (lowest first)' },
    { value: 'utilization_desc', label: 'Utilization (highest first)' },
    { value: 'utilization_asc', label: 'Utilization (lowest first)' },
];

const store = useCardBenefitsStore();
const { insightsSortBy } = storeToRefs(store);

const draft = ref(insightsSortBy.value);

watch(
    () => props.isOpen,
    (open) => {
        if (open) {
            draft.value = insightsSortBy.value;
        }
    }
);

const handleApply = () => {
    store.setInsightsSortBy(draft.value);
    emit('close');
};

const handleCancel = () => {
    emit('close');
};
</script>
